import React, { memo, forwardRef } from "react";
const SvgTheta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.464 24.96c-1.312 0-2.4-.368-3.264-1.104-.848-.752-1.48-1.816-1.896-3.192-.416-1.392-.624-3.056-.624-4.992 0-1.952.192-3.624.576-5.016.384-1.392 1-2.456 1.848-3.192.864-.736 1.984-1.104 3.36-1.104 1.328 0 2.424.368 3.288 1.104.864.72 1.504 1.776 1.92 3.168.432 1.392.648 3.072.648 5.04 0 1.936-.2 3.6-.6 4.992-.384 1.376-1.008 2.44-1.872 3.192-.848.736-1.976 1.104-3.384 1.104zm0-1.752c.832 0 1.512-.24 2.04-.72.544-.48.952-1.232 1.224-2.256.272-1.024.424-2.36.456-4.008h-7.368c.032 1.632.168 2.96.408 3.984.256 1.024.648 1.784 1.176 2.28.528.48 1.216.72 2.064.72zm-3.648-8.616h7.344c-.048-1.456-.208-2.656-.48-3.6-.272-.96-.672-1.672-1.2-2.136-.528-.48-1.2-.72-2.016-.72-.816 0-1.488.24-2.016.72-.512.464-.896 1.176-1.152 2.136-.256.944-.416 2.144-.48 3.6z"
      />
    </svg>
  );
});
SvgTheta.displayName = "SvgTheta";
const MemoForwardRef = memo(SvgTheta);
export default MemoForwardRef;
